import CustomAppsList from "src/components/CustomApps/List/CustomAppsList";

const CustomApps = () => {
  return <CustomAppsList />;
};

export default CustomApps;
